import { graphql } from 'gatsby';
import { Paper } from 'lucid-components-react';
import React from 'react';

import Link from '../../link/link';
import { Drupal_ParagraphNineteenQuote } from '../../../generated/graphql';
import './nineteen-quote.scss';
import {
  MarketingPageElementLocation,
  MarketingPageElementType
} from '@lucid/gatsby-theme-lucid';
import LazyLoad from 'react-lazyload';

interface Props {
  entity: Drupal_ParagraphNineteenQuote;
}

const NineteenQuote = ({
  entity: { fieldQuote, fieldImage, fieldAttribution, fieldQuoteLink }
}: Props) => {
  const linkPath = fieldQuoteLink?.url?.path;
  const finalPath = linkPath?.includes('node')
    ? fieldQuoteLink?.url?.translate?.path
    : linkPath;

  return (
    <section className="nineteen-quote">
      <div
        className={`nineteen-quote__wrapper lucid-container ${
          fieldQuoteLink ? '' : 'nineteen-quote__wrapper--no-link'
        }`}
      >
        <Paper className="nineteen-quote__content">
          <p className="nineteen-quote__quote">{fieldQuote}</p>
          <p className="nineteen-quote__attribution">{`—${fieldAttribution}`}</p>
        </Paper>
        <div className="nineteen-quote__image-wrapper">
          <LazyLoad>
            <img
              className="nineteen-quote__image"
              src={fieldImage!}
              alt={fieldAttribution!}
            />
          </LazyLoad>
          {finalPath && (
            <Link
              primary
              inverse
              to={finalPath}
              className="nineteen-quote__link"
              beaconEvent={{
                name: 'clickedMarketingPageElement',
                elementLocation: MarketingPageElementLocation.body,
                elementDetail: 'case-study',
                elementType: MarketingPageElementType.link
              }}
            >
              {fieldQuoteLink?.title}
            </Link>
          )}
        </div>
      </div>
    </section>
  );
};

export default NineteenQuote;

export const query = graphql`
  fragment nineteenQuote on Drupal_ParagraphNineteenQuote {
    fieldAttribution
    fieldImage
    fieldQuote
    fieldQuoteLink {
      title
      url {
        path
        translate(language: EN) {
          path
        }
      }
    }
  }
`;
